import { useContext } from "react";
import { DeskSubnavContext } from "@/contexts/deskSubnavContext";

export function useDeskSubnav() {
  const context = useContext(DeskSubnavContext);
  if (!context) {
    throw new Error("useDeskSubnav must be used within DeskSubnavProvider");
  }
  return context;
}
